import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { installGlobalErrorReporting } from "@/lib/clientLog";

installGlobalErrorReporting();

document.documentElement.classList.remove("dark");
document.documentElement.setAttribute("data-color-mode", "light");
document.documentElement.setAttribute("data-product", "bindley");
if (!localStorage.getItem("lms_theme")) {
  localStorage.setItem("lms_theme", "light");
}

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
